export interface AudioPlaybackHandle {
  pause: () => void;
}

const activeHandles = new Set<AudioPlaybackHandle>();

export const registerAudioPlayback = (handle: AudioPlaybackHandle) => {
  activeHandles.add(handle);

  return () => {
    activeHandles.delete(handle);
  };
};

export const pauseOtherAudioPlaybacks = (current: AudioPlaybackHandle) => {
  activeHandles.forEach((handle) => {
    if (handle !== current) handle.pause();
  });
};

export const pauseAllAudioPlaybacks = () => {
  activeHandles.forEach((handle) => handle.pause());
};
